import React, { useCallback } from 'react';
import {
  BUTTON_TYPE,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE
} from '../../../global/constants';
import Button from '../../button';
import IconButton from '../../button/iconButton';
import CreateFilesDropdown from '../../dropdowns/createFilesDropdown';
import TaskFilterCustomDropdown from '../../taskFilterDropdown';
import { TaskIcons } from '../styles';

interface TaskFilterBarProps {
  isTaskFilterOpen: boolean;
  view: { isTask: boolean; isFile: boolean; isMilestone: boolean; isMessages: boolean; isOverview: boolean };
  isMobile: boolean;
  renderDropdownItems?: JSX.Element;
  taskFilterContent: React.ReactNode;
  fileFilterContent: React.ReactNode;
  onCreateTask: () => void;
  onCreateMilestone: () => void;
}

const TaskFilterBar: React.FC<TaskFilterBarProps> = ({
  isTaskFilterOpen,
  view,
  fileFilterContent,
  isMobile,
  onCreateMilestone,
  onCreateTask,
  renderDropdownItems,
  taskFilterContent
}) => {

  const renderTaskFilterIcon = useCallback(
    () => (
      <IconButton
        iconName='filters-icon'
        size={isMobile ? ICON_BUTTON_SIZE.LARGE : ICON_BUTTON_SIZE.MEDIUM}
        variant={ICON_BUTTON_TYPE.TERTIARY}
      />
    ),
    [isMobile]
  );

  if (isMobile) return null;

  if (view.isTask) {
    return (
      <TaskIcons>
        <TaskFilterCustomDropdown
          trigger={renderTaskFilterIcon}
          isTaskFilterOpen={isTaskFilterOpen}
          content={taskFilterContent}
          isMinWidth={289}
        />
        <Button
          title='New Task'
          variant={BUTTON_TYPE.PRIMARY}
          iconName='plus-icon'
          iconPosition='start'
          buttonType='button'
          size='small'
          onClick={onCreateTask}
        />
      </TaskIcons>
    );
  }

  if (view.isFile) {
    return (
      <TaskIcons>
        <TaskFilterCustomDropdown trigger={renderTaskFilterIcon} content={fileFilterContent} isMinWidth={255} />
        <CreateFilesDropdown renderDropdownItems={renderDropdownItems} />
      </TaskIcons>
    );
  }

  if (view.isMilestone) {
    return (
      <IconButton
        iconName='plus-icon'
        size={ICON_BUTTON_SIZE.MEDIUM}
        variant={ICON_BUTTON_TYPE.PRIMARY}
        onClick={onCreateMilestone}
      />
    );
  }

  return null;
};

export default TaskFilterBar;
